// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"52a37c51","405":"97906d95","471":"b49d7aab","622":"42d7f281","974":"78b41244"}[chunkId] + ".css";
};